module.exports = __webpack_public_path__ + "img/image_mydriatic.9ba7da9c.jpg";